import { useNftx } from '@nftx/react';
import { QueryKey } from '../../queryKeys';
import { Address, BadRequestError } from 'nftx.js';
import useStreamQuery from '../../useStreamQuery';

const useVaultAssets = (
  {
    vaultId,
    assetAddress,
  }: {
    vaultId?: string;
    assetAddress?: Address;
  },
  opts?: { enabled?: boolean }
) => {
  const {
    core: { streamAssets },
    network,
  } = useNftx();
  const enabled = !!((vaultId || assetAddress) && opts?.enabled !== false);

  return useStreamQuery(
    [QueryKey.VAULT_ASSETS, network, vaultId, assetAddress],
    () => {
      if (vaultId) {
        return streamAssets({ network, vaultId });
      }
      if (assetAddress) {
        return streamAssets({ network, assetAddress });
      }
      throw new BadRequestError();
    },
    { enabled, keepPreviousData: false }
  );
};

export default useVaultAssets;
